import {
  Box,
  Step,
  StepButton,
  Stepper,
} from '@hiiretail/react-foundation-ui';
import { ReactNode } from 'react';

type StepperComponentProps = {
  steps: string[] | ReactNode[];
  activeStep: number;
  onStepChange: (step: number) => void;
};

export const StepperComponent = (
  { steps, activeStep, onStepChange }: StepperComponentProps
) => 
  // if only parrent item no need show the Stepper 
  steps.length > 1 ? (
    <Box sx={{ width: '100%', mt: 2, minWidth: 600 }}>
      <Stepper nonLinear activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepButton onClick={() => onStepChange(index)}>{label}</StepButton>
          </Step>
        ))}
      </Stepper>
    </Box>
  ) : null;